var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTimezoneIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7503 9.66662C17.7503 5.24835 14.1685 1.66663 9.75016 1.66663C5.33179 1.66663 1.75 5.24835 1.75 9.66662C1.75 14.0849 5.33179 17.6666 9.75016 17.6666",
    stroke: "#525059",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 9.66663H17.7503",
    stroke: "#525059",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.827 9.66664C12.6758 6.74111 11.5982 3.93943 9.75002 1.66663C7.9018 3.93943 6.82423 6.74111 6.6731 9.66664C6.82423 12.5922 7.9018 15.3938 9.75002 17.6667",
    stroke: "#525059",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_3197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0833 22C19.397 22 22.0833 19.3137 22.0833 16C22.0833 12.6863 19.397 10 16.0833 10C12.7695 10 10.0833 12.6863 10.0833 16C10.0833 19.3137 12.7695 22 16.0833 22Z",
    stroke: "#525059",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0833 14V16.2894L18.0833 19",
    stroke: "#525059",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_3197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.0003,
    height: 14,
    fill: "white",
    transform: "translate(9.08325 9)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimezoneIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TimezoneIcon.6c938239.svg";
export { ForwardRef as ReactComponent };